/* eslint-disable max-len */
module.exports = {
  // 零碎名词
  get_secret_key: 'Get SecretKey',
  history_session: 'History Session',
  remember_session: 'Remember Session',
  create_session: 'Create Session',
  edit_session: 'Edit Session',
  delete_session: 'Delete Session',
  user_type: 'User Type',
  authorized_user: 'Authorized user',
  root_account: 'Root account',
  sub_account: 'Sub-account',
  collaborator_id: 'collaborator',
  add_user: 'Add User',
  specified_domain: 'Specified Domain',
  MAZ_configuration: 'MAZ configuration',
  MAZ_state: {
    MAZ: 'Enabled',
    OAZ: 'Off',
    Off: 'Off',
    AccessDenied: 'Unknown (No access to HeadBucket)',
    Unknown: 'Unknown',
  },

  // 存储桶
  bucket: [
    'Bucket', // 0
    'Bucket: {bucket}', // 1
  ],
  add_bucket: 'Add Bucket',
  bucket_name: 'Bucket Name',
  bucket_detail: 'Bucket Info',
  switch_bucket: 'Switch Bucket',
  select_bucket: 'Select bucket',
  remote_folder: 'Bucket Path',
  create_bucket: ['Create bucket', 'Bucket created'],
  delete_bucket: ['Delete bucket', 'Bukcet deleted'],
  edit_bucket: 'Edit bucket',
  edit_bucket_acl: 'Edit bucket ACL',
  edit_bucket_version_control: 'Edit version control',

  // 标签
  tag: 'tag',
  bucket_tag: 'Bucket Tag',
  tag_management: 'Tag management',
  tag_key: 'Tag Key',
  tag_value: 'Tag Value',
  add_tags: 'Add Tags',
  tag_help: 'Learn more',
  delete_tag: 'Delete Tag',
  set_tag: 'Set Tag',

  // 传输管理
  transmission_management: 'Transmission Management',
  upload_domain: 'Upload Domain',
  download_domain: 'Download Domain',
  cos_default_domain: 'COS default domain',

  // 智能分层
  intelligent_tiering: 'Intelligent tiering',
  intelligent_tiering_document: 'Intelligent tiering documents',
  intelligent_tiering_access_denied: 'Unknown (No access to IntelligentTiering)',

  // 域名
  domain: 'Domain',
  domain_management: 'Domain Management',
  view_domain: 'View Domain',
  default_cdn_domain: 'Default CDN Acceleration Domain',
  current_status: 'Status',
  acceleration_domain: 'Acceleration Domain Name',
  acceleration_region: 'Acceleration Region',
  origin_server_type: 'Origin Server Type',
  origin_server_domain_name: 'Origin Server Domain Name',
  origin_pull_authentication: 'Origin-pull Authentication',
  CDN_authentication: 'CDN Authentication',
  default_cdn_domain_help: 'Default CDN Acceleration Domain Guides',
  custom_cdn_domain_help: 'Custom CDN Acceleration Domain Guides',
  custom_cdn_domain_help_comment: [
    'Note: Make sure that the added domain name has been filed and the corresponding CNAME has been set on the DNS provider website.',
    'For more information or help, please refer to',
  ],
  custom_domain_help: 'Custom Origin Domain Guides',
  custom_domain_help_comment: [
    'Note: This bucket provides service in Mainland China. Please make sure that your domain has been filed. Domain that is not filed cannot be bound to the bucket in Mainland China as a custom domain.',
    'Meanwhile, set corresponding CNAME records on DNS service provider website and route to COS.',
    'For more information or help, please refer to',
  ],
  custom_cdn_domain: 'Custom CDN Acceleration Domain',
  custom_domain: 'Custom Origin Server Domain',
  domain_type: 'Origin Server Type',
  cname: 'CNAME',
  statu: 'Statu',
  speed_area_map: {
    mainland: 'Acceleration in Mainland China',
    overseas: 'Acceleration outside Mainland China',
    global: 'Global Acceleration',
  },
  statu_map: {
    online: 'online',
    offline: 'offline',
    processing: 'deploying',
    rejected: 'Domain name verification failed, domain name filing expired/because of cancellation',
    ENABLED: 'online',
    DISABLED: 'offline',
  },
  origin_type_map: {
    REST: 'Default origin server',
    cos: 'Default origin server',
    web: 'Static website origin server',
    WEBSITE: 'Static website origin server',
    ACCELERATE: 'Global acceleration origin server',
    V4_REST: 'Default origin server(old)',
  },

  // 访问路径
  access_path: ['Bookmark Path', 'Bookmark Path: {path}'],
  access_path_simple: 'Path',
  add_access_path_simple: 'Add Path',
  add_access_path: ['Add collection path', 'Add collection path'],
  edit_access_path: 'Edit collection path',
  delete_access_path: ['Delete collection path', 'Delete collection path'],

  show_in_local_folder: 'Show in Folder',
  show_in_remote_folder: 'Show in Bucket',
  prefix_matching: 'Prefix match',

  region_name: 'Region',
  endpoint: 'Endpoint',
  access_domain: 'Domain',
  bucket_domain: 'Bucket domain',
  domainTypeMap: {
    defaultCos: 'Default Origin Domain',
    defaultWebsite: 'Default Website Domain',
    defaultCdn: 'Default CDN Acceleration Domain',
    customCdn: 'Custom CDN Acceleration Domain',
    customCos: 'Custom Origin Server Domain',
  },

  ETag: 'ETag',
  headers: 'Headers',

  // 对象
  object_url: 'Object location',
  copy_link_with_expires: 'File Share',
  copy_link_without_sign: 'Copy object url without signature.',
  copy_link_with_sign: 'Copy url with signature, select expires time',
  current_file_acl: 'Current file acl',
  loading_file_acl: 'Loading object acl',
  copy_files: {
    msg: '{count} file / folder copyed successfully',
    success_without_sign: 'Object url copy success, Link without signature.',
    success_with_sign: 'Temporary object url copy success, Link effective for {duration} {unit}.',
    success: '{count} file / folder pasted successfully',
    fail: '{count} file / folder pasted failed',
  },
  object_count: 'Number of Objects',

  // 权限
  permission: 'Permissions',
  public_permission: 'Public Permissions',
  acl: 'ACL',
  acl_simple: 'ACL',
  public_pemission: 'Public Permissions',
  acl_map: {
    'public-read-write': 'Public (read-write)',
    'public-read': 'Public Read/Private Write',
    private: 'Private (read-write)',
    default: 'Inherit',
    'tce-default': 'Default',
    AccessDenied: 'Unknown (No access to GetObjectACL)',
    Unknown: 'Unknown',
    'unknown-with-timeout': 'Unable to fetch (Please select the link type manually)',
  },
  user_acl: 'User ACL',
  set_user_acl: 'Set user acl',
  delete_user_acl: 'Delete user acl',
  user_acl_map: {
    FULL_CONTROL: 'Full control',
    READ: 'Reads',
    WRITE: 'Write',
    READ_ACP: 'Read ACL',
    WRITE_ACP: 'Write ACL',
  },
  edit_acl: 'Edit ACL',
  permission_management: 'Permission Management',
  quick_auth: 'Quick Authorization',

  // 存储类型
  storage_class: 'Storage Class',
  storage_class_map: {
    STANDARD: 'Standard Storage',
    STANDARD_IA: 'Standard IA Storage',
    COLD: 'Cold Storage',
    ARCHIVE: 'Archive Storage',
    DEEP_ARCHIVE: 'Deep Archive Storage',
    NEARLINE: 'Nearline Storage',
    INTELLIGENT_TIERING: 'Intelligent Tiering Storage',
    MAZ_STANDARD: 'MAZ Standard Storage',
    MAZ_STANDARD_IA: 'MAZ Standard IA Storage',
    MAZ_COLD: 'MAZ Cold Storage',
    MAZ_INTELLIGENT_TIERING: 'MAZ Intelligent Tiering Storage',
  },
  storage_class_short_map: {
    STANDARD: 'Standard',
    STANDARD_IA: 'Standard IA',
    COLD: 'Cold',
    ARCHIVE: 'Archive',
    DEEP_ARCHIVE: 'DEEP ARCHIVE',
    NEARLINE: 'Nearline',
    INTELLIGENT_TIERING: 'Intelligent Tiering',
    MAZ_STANDARD: 'MAZ Standard',
    MAZ_STANDARD_IA: 'MAZ Standard IA',
    MAZ_Cold: 'MAZ Cold',
    MAZ_INTELLIGENT_TIERING: 'MAZ Intelligent Tiering',
  },
  edit_storage_class: 'Edit StorageClass',

  // 版本控制
  version_control: 'Versioning',
  versions: 'Versions',
  version_id: 'VersionId',
  version_map: {
    disabled: 'Disabled',
    enabled: 'Enabled',
    suspended: 'Suspended',
    accessdenied: 'Access Denied',
    unknown: 'Unknown',
  },
  deleted_flag: 'Deleted',
  versioning_document: 'Versioning documents',
  open_versioning: 'Open',

  // 全球加速
  global_acceleration: 'Global Acceleration',
  global_acceleration_document: 'Global acceleration document description',
  global_acceleration_domain: 'Global accelerated domain name',
  global_acceleration_status: {
    Disabled: 'Disabled',
    Enabled: 'Enabled',
    Suspended: 'Suspended',
    AccessDenied: 'Access Denied',
    Unknown: 'Unknown',
  },
  bucket_does_not_enable_global_acceleration: 'Bucket does not enable global acceleration',
  learn_about_global_acceleration: 'Learn about global acceleration',
  enable_global_acceleration: 'Enable global acceleration',

  // 分块上传
  object_path: 'Object Path',
  initiator_ID: 'Upload Initiator ID',
  owner_ID: 'Owner ID',
  uploaded_size: 'Uploaded Size',
  uploaded_part_count: 'Uploaded part count',
  uploadId: 'Upload Task ID',
  incomplete_multipart_upload: 'Incomplete multipart Upload',
  clear_incomplete_uploads: 'Clear Incomplete Multipart Uploads',
  multipart_upload_name: 'Multipart Upload Name',
  multipart_upload_path: 'Path',
  loading_incomplete_upload_info: 'Loading...',

  // 格式校验
  validate: {
    invalid_input: 'Format error found. Please enter again',
    path_name_length: 'Access path cannot be longer than 255 characters.',
    folder_name_length: 'File folder name cannot be longer than 255 characters.',
    empty_folder_name: 'Folder name is not allowed empty.',
    empty_file_name: 'File name is not allowed empty.',
    invalid_char_in_folder_name: 'file folder name include invalid characters \\ / : * ? " < > |',
    bucket_name_format_simple: "Only support lowercase letters, numbers and '-'. Up to 50 characters",
    bucket_name_length: 'It cannot be longer than 50 characters.',
    bucket_name_char: 'Only support lowercase letters, numbers and "-". Up to 50 characters',
    bucket_name_end_with: ['Bucket name cannot start with "-"', 'Bucket name cannot end with "-"'],
    bucket_name_format: 'Only support lowercase letters, numbers and "-". Up to 50 characters',
    secret_id_empty: 'SecretId empty',
    secret_key_empty: 'SecretKey empty',
    region_key_empty: 'Region empty',
    secret_key_must_start_with_AKID: 'SecretId must start with "AKID"',
    secret_id_format: 'The number of SecretId characters should be 36 characters.',
    secret_key_format: 'The number of SecretKey characters should be 32 characters.',
    access_path_format: 'The format is Bucket or Bucket/Object-prefix, such as a-1251902136.',
    need_positive_int: 'Complete positive integer',
    need_positive_number: 'Please enter a positive number',
    support_number_and_letters: 'Support number, letters.',
    support_char_most: 'Note: {num} characters at most.',
    empty_input_content: 'Input cannot be empty',
    service_domain_format: 'Invalid service domain format',
    bucket_domain_format: 'Invalid bucket domain format',
    enter_account_id: 'Enter account ID',
    invalid_account_id_format: 'Invalid account ID format',
    cannot_be_root_via_sub: 'Account ID cannot be root account when account type is sub-account',
    choose_at_least_one_permission: 'Please choose at least one permission',
    submit_new_user: 'Please submit the new user',
    enter_a_full_tag_key_and_tag_value: 'Enter a full tag key and tag value',
    tag_value_length_cannot_be_greater_than_255_characters: 'Tag value length cannot be greater than 255 characters',
    tag_key_length_cannot_be_greater_than_127_characters: 'Tag key length cannot be greater than 127 characters',
    tag_keys_cannot_begin_with: "Tag keys cannot begin with Regular expression, '项目', 'project', 'qcs:'",
    repetitive_tag_keys_are_not_allowed: 'Repetitive tag keys are not allowed',
    share_valid_time: [
      'The current account is a primary account, with a maximum validity of 2 hours; sub-accounts support up to 1.5 days.',
      'The longest valid time supported by sub-account is 1.5 days',
      'The longest valid time is 2 hours',
    ],
    only_allow_one_decimal: 'Only supports accurate to one decimal place',
    enter_6_extract_code: 'Please enter the 6-digit extraction code',
    folder_name: [
      'Folder name is not allowed to be empty',
      'File folder name cannot be longer than 255 characters',
      'Folder name is cannot begin with "/"',
      'Folder name can not contain continuous "/"',
      'Folder name is not allowed to be "..".',
      'The total length of current path is up to limit of 850 bytes.',
    ],
    file_name: [
      'File name is not allowed to be empty',
      'File name is cannot begin with "/"',
      'File name can not contain continuous "/"',
    ],
  },

  // 占位符
  placeholder: {
    file_prefix: 'Prefix matching',
    secret_id: 'Please enter API SecretId',
    secret_key: 'Please enter API SecretKey',
    add_path: 'Not required, add access path',
    add_remark: 'Not required, Add remark',
    bucket: 'Format such as: test-1250000000',
    region: 'Format such as: ap-guangzhou',
    root_account_id: 'Enter root account ID',
    sub_account_id: 'Enter sub-account ID',
    collaborator_id: 'Enter collaborator-account ID',
    tag_key: 'Enter a tag key',
    tag_value: 'Enter a tag value',
    such_as_index_html: 'such as index.html',
    such_as_pages_error_html: 'such as pages/error.html',
    support_4xx_error_code: '4XX error code is supported',
    enter_prefix_such_as_images: 'enter_prefix_such_as_images: Please enter a prefix, such as images/',
    replacement_prefix: 'The replacement prefix',
    replacement_path: 'The replacement path',
  },

  // 提示
  tips: {
    whether_to_enter_access_path:
      'If the current account has permissions for all buckets, you do not need to enter the access path; if the current account only has permissions for a bucket or a directory under the bucket, you need to enter the access path in the format: Bucket or Bucket / Object-prefix, As test-1250000000',
    empty_bucket_list: 'The bucket list is empty.',
    create_bucket_in_console: 'Please create Bucket',
    empty_file: 'No files',
    history_session_empty: 'No history session',
    empty_history_file: 'No history files',
    empty_files_or_folders: 'Please choose the file/folder',
    delete_replication:
      'Note: current bucket has replication rules, delete action will be synchronized to target bucket.',
    share_replication:
      'Note: current bucket has replication rules. Upload and delete operations via sharing link will be synchronized to the target bucket',
    same_name_file_exist: 'If the file of the same name already exists:',
    access_path_describe:
      'Access path can be a [Bucket] or a [Path under the bucket]. Please make sure the added path is authorized.',
    private: 'private (read-write): need to verify your identity before do some operations on object',
    'public-read': 'public read & private write: anonymous read and write with identification.',
    'public-read-write': 'Everyone can do some operations on object.',
    show_thumbnail_will_generate_CI_fee:
      'Displaying thumbnail is based on Cloud Infinite (CI) in this region and it may incur basic image processing fee after opening.',
    show_thumbnail_will_generate_download_traffic:
      'Displaying thumbnail will download complete file in this region and it may generate download traffic after opening.',
    version_control_describe:
      'When versioning is enabled, the historical versions of objects will exist as separate objects. They will occupy storage space and incur storage capacity fees.',
    global_acceleration_describe:
      'Note: With the global acceleration function enabled, you can transfer files to the bucket more quickly and stably.',
    clear_history_version: [
      'Clear history version',
      'This operation will clear the historical version of all objects in the current directory, please exercise caution!',
    ],

    read_bucket_ACL_permissions: 'Read bucket ACL permissions',
    write_bucket_ACL_permissions: 'Write bucket ACL permissions',
    read_object_ACL_permissions: 'Read object ACL permissions',
    write_object_ACL_permissions: 'Write object ACL permissions',

    choose_public_acl:
      'Note: Public read ACL allows anonymous users to read data in your bucket. It is recommended to use private ACL to ensure your data security.',

    /**
     * empty file list different tips
     */
    // 1. 无存储桶权限
    no_access_to_bucket: "You don't have bucket permission.",
    concat_root_to_auth: 'Please contact the root account to request permission',
    // 2. 搜索无结果
    no_result_found: 'No results found',
    try_diffrent_keyword: 'Please try different keywords',
    // 3. 文件夹为空
    empty_folder: 'This folder is empty',
    drag_here: 'Drag here to upload',

    // 清空存储桶提示
    clear_bucket: [
      'Clearing bucket will clear all objects in this bucket, including object history versions and multipart uploads. (',
      'The cleared data is unrecoverable',
      ') If you confirm you want to clear the bucket, click "OK".',
    ],
    object_count:
      'Number of Objects refers to the number of objects in a bucket. When versioning is enabled, the historical versions of objects will exist as separate objects and be counted toward the total quantity.',
    specified_domain: 'If you modify the configured or added domain name, the object address will change accordingly.',
    open_versions: ["If you don't want to overwrite, you can {open} versioning.", 'open'],
    MAZ_configuration: 'After you set MAZ configuration, your data will be stored in different available zone.',
    empty_history_session: 'No history session.',
    tag_keys:
      'Tag keys are case sensitive and support Chinese, a-z, A-Z, 0-9, +, -, _, =, /, ., :, @ and other characters',
    tag_values:
      'Tag values are case sensitive and support Chinese, a-z, A-Z, 0-9, +, -, _, =, /, ., :, @ and other characters',
    folder_name: [
      '1. Numbers, letters, Chinese characters, and visible characters are allowed',
      '2. Use "/" to split path, you can quickly create subdirectories',
      '3. Empty folder, continuous "/" or starting with a "/" are not allowed',
      '4. ".." is not allowed to be a folder name',
    ],
    file_name: [
      '1. Numbers, letters, Chinese characters, and visible characters are allowed',
      '2. Use "/" to split path, you can quickly create file in subdirectories',
      '3. Empty file, continuous "/" or starting with a "/" are not allowed',
    ],

    // 上传下载限速
    single_threaded_upload_speed_limit:
      'Total Upload Speed Limit = Single-threaded Upload Speed Limit x File Parallel Limit*Chunk Parallel Limit',
    single_threaded_download_speed_limit:
      'Total Download Speed Limit = Single-threaded Download Speed Limit x File Parallel Limit*Chunk Parallel Limit',

    // 批量文件下载
    install_latest_client: 'Install the Latest Version of COSBrowser',
    multi_download: [
      'COSBrowser Web only supports downloading single file. If you want to download files or folders in batch, please download and install COSBrowser client first. If you haven\'t installed yet, click to {0}',
      'If you have installed COSBrowser and failed to start it several times, manually open the COSBrowser client or click to {0}',
      'Opening the COSBrowser client',
    ],
    // 编辑器模式权限提示
    no_permission: 'No permission',
    loading: 'loading',
    list_empty: 'List is empty',
  },

  // 确认提示
  confirm: {
    authorized_actions: ['Confirm Authorized Actions', 'Are you sure you want to authorize this account ID {id}?'],
    delete_actions: [
      'Confirm Delete Actions',
      'Are you sure you want to delete the authorization for this account ID {id}?',
    ],
    exit: 'There are upload / download tasks in progress. Are you sure to stop and exit?',
    logout: 'There are unfinished upload / download tasks. Are you sure to clear and logout?',
    rename_cover: 'Same file name exist, Do you confirm to cover it?',
    paste_param_cover: 'This operation overrides the file of this same name.Do you confirm to {type} it？',
    paste_cover: 'Pasting overrides the file of the same name. Do you confirm to paste it?',
    delete_files_or_folders:
      'Are you sure you want to delete these file/folder?\nNote: the data will be permanently unrecoverable after deletion.',
    delete_task: 'Are you sure to delete all tasks? Note: the data is unrecoverable and accessible after deletion.',
    delete_access_path: 'Are you sure to delete this access path: {path}?',
    delete_bucket:
      'Are you sure you want to delete the bucket: {bucket}? Note: All datas within the bucket will be deleted, and the data will be permanently unrecoverable.',
    delete_a_version_object: 'Do you confirm to delete this object "{name}" ( Version date is {time} ) ？',
    delete_some_version_object:
      'Do you confirm to delete this folder "{name}"? Clearing will clear all objects in this folder, including object history versions. Note:The deleted files cannot be recovered or accessed.',
    delete_history_version_object:
      'Do you confirm that you want to clear the historical version of all files in the current directory? Note:The deleted files cannot be recovered or accessed.',
    clear_bucket: [
      'Confirm to clear the selected bucket?',
      'Clearing a bucket will delete all objects and incomplete multipart uploads in this bucket. The deleted data is unrecoverable and inaccessible.',
      'Please enter bucket name',
      'to clear it',
    ],
    pause_intelligent_tiering: [
      'Are you sure to turn on intelligent tiering?',
      'Once your bucket is enabled for INTELLIGENT TIERING, it cannot be disabled or suspended, nor can its configuration information be modified.',
    ],
    pause_versioning: [
      'Are you sure you want to pause versioning?',
      'This suspends the creation of object versions for all operations but preserves any existing object versions. If you have any replication rules, they will be suspended as well.',
      'Versioning documents',
    ],
    delete_incomplete_uploads: 'Are you sure you want to delete the incomplete multipart uploads with path "{path}"?',
    clear_incomplete_uploads: 'Are you sure you want to clear all the incomplete multipart uploads in this bucket?',
    delete_session: [
      'Are you sure you want to delete session {name} ?',
      'Are you sure you want to delete quick access path {path} ?',
    ],
    delete_not_exist_sub_account:
      'Sub account {subUin} does not exist. If confirm, it would delete authorized record with sub-account not exist.',
    check_remember: 'Uncheck will delete this session of SecretId & SecretKey (includes access path)',
    delete_tag: 'Are you sure you want to delete the tag {tag}',

    // 批量文件下载
    open_cosbrowser: 'Open COSBrowser',
    restart_cosbrowser: 'Restart',
    login_change: 'Login account has changed',
    switch_login: 'There are other accounts on the current page requesting to log in, whether to switch to other accounts to log in.',
    confirm_text: 'Log in to another account',
    cancel_text: 'Keep current account',
  },

  /**
   * 统计弹窗
   */
  statistics_alert: [
    'Data in this page is provided by Cloud Monitor and has a certain delay. It is only for your reference. For detailed billing data, view in',
    'Billing Center',
    '.',
  ],

  /**
   *
   * 设置页面
   *
   * */
  reset_default: 'Reset Default',

  // 账号配置
  account: 'Account',

  // 关于配置
  about: 'About',
  cosBrowser: 'COSBrowser - Tencent Cloud COS Client',
  version_update: 'Update',
  has_new_version: 'new',
  no_new_version: 'No Update',
  check_update: 'Check for latest version.',
  update_now: 'Update now',
  update_tip: [
    'Found new version, do you get the update immediately?',
    'New version has major changes, whether to get the update immediately?',
  ],
  get_update: 'Get update',
  updating: 'A new version is downloading...',
  update_downloaded: 'New version downloaded successfully.',
  update_restart_app: 'The Setting will take effect after restart app, Restart current software now?',
  client_download: 'Client Download',
  feedback: 'Feedback',
  instructions: 'Instructions',
  update_log: 'Updated Logs',
  local_log: 'Local Logs',
  privacy_policy: 'Privacy Policy',
  copyright: `2017-${new Date().getFullYear()} Tencent. All Rights Reserved.`,

  // 通用配置
  general: 'General',
  language: 'Language',
  chinese: 'Chinese',
  english: 'English',
  service_domain: 'EndPoint/Service Domain',
  service_domain_placeholder: 'Default empty',
  service_domain_tip: 'Use as GetService Domain\nExample: cos.ap-beijing.myqcloud.com\nDefault empty',
  bucket_domain_setting: 'Bucket Domain Template',
  bucket_domain_tip:
    'Use as Bucket Domain Template\nSupport template "{Bucket}" and "{Region}"\nExample: {Bucket}.cos.{Region}.myqcloud.com\nDefault empty',
  force_use_https: 'Use HTTPS',
  not_use_https: 'Not use HTTPS',
  strict_ssl: 'Verify HTTPS certificates',
  ignore_ssl_error: 'Ignore HTTPS SSL errors',
  auto_update: 'Auto Update',
  path_style: 'Use Path Style',
  path_style_tip:
    'If use path style, bucket name will put in request pathname instead of domain\nThe bucket name also participates in signature calculate. For example, upload files to test-1250000000：\nPUT https://cos.ap-beijing.myqcloud.com/test-1250000000/1.jpg\n/test-1250000000/1.jpg Participate in signature computation as pathname parameter of signature.',

  // 代理配置
  proxyType: 'Proxy Type',
  proxy: 'Proxy',
  no_proxy: 'No proxy, direct connect',
  system_proxy: 'Use system proxy',
  custom_proxy: 'Use proxy',

  // 上传配置
  file_parallel_limit: 'File Parallel Limit',
  chunk_parallel_limit: 'Chunk Parallel Limit',
  chunk_retry_times: 'Error Retry Times',
  chunk_retry_interval: 'Chunk Retry Interval',
  upload_double_check: 'Secondary verification after uploading',
  upload_double_check_tips: '(After uploading, get the object information and compare with the local file)',
  upload_add_meta_md5: 'Calculate and add x-cos-meta-md5 Header (Slower)',
  upload_add_meta_md5_tips: '(Used to verify completeness when downloading objects from other channels)',
  single_threaded_upload_speed_limit: 'Single-threaded Upload Speed Limit',
  // upload_add_meta_md5: 'Calculate and add x-cos-meta-md5 Header (Slower)', 下线该功能
  // upload_add_meta_md5_tips:
  //  '(Used to verify completeness when downloading objects from other channels)', 下线该功能
  enter_0_for_unlimited: 'Enter 0 for unlimited',
  please_enter_an_integer_from_0_100: 'Please enter a number from 0-100',

  // 下载配置
  change_location_tip: 'Change Location',
  ask_before_download: 'Ask where to save before download',
  download_to_location: 'Download to specified location',
  single_threaded_download_speed_limit: 'Single-threaded Download Speed Limit',

  // 【上传】对象标签
  object_tag: 'Obect Tags',

  /**
   * oauth 登录
   * */
  oauth_login: 'Login with Qcloud',

  /**
   * 静态网站
   * */
  static_website_configuration: 'Static Website Configuration',
  static_website: {
    endpoint: 'Endpoint',
    force_HTTPS: 'Force HTTPS',
    index_document: 'Index Document',
    error_document: {
      name: 'Error Document',
      tip: 'An error document will be returned if an access error occurs and no redirect rule is matched.',
    },
    redirect_rules: 'Redirect Rules',
    http_error_code: 'Http error code',
    prefix_matches_with: 'prefix matches with',
    replace_path: 'Replace path',
    replace_prefix: 'Replace prefix',
    Replace_path_prefix: 'Replace path prefix',
    add_rule: {
      name: 'Add Rule',
      tip:
        'Once a redirect rule is set, COS will first check whether the request matches this rule. If an error code or prefix is ​​matched, COS will directly return 302 and replace the Location with a corresponding path.',
    },
    replace_content: 'Replace content',
    enabled: 'Enabled',
    closed: 'Closed',
    learn_more: 'Learn more',
    suffix_validate: ['Index document', 'Index document cannot be empty', 'Index documents can not inculde "/" or "?"', 'Cannot start with "/"'],
    error_document_validate: ['An error document will be returned if an access error occurs and no redirect rule is matched.', 'Error document cannot contain interrogation mark'],
    routing_rules_error_code_validate: ['Please enter error code', 'Http error code only supports 4xx'],
    routing_rules_prefix_validate: ['Please enter matching prefix', 'Prefix cannot include "?"'],
    routing_rules_replace_validate: ['Enter a replacement path/prefix', 'Replace content can not include "?"'],
    enable_force_HTTPS_confirm: {
      title: 'Are you sure you want to enable force HTTPS?',
      message: 'If you configure a CDN domain to pull content from a origin static website using HTTP (unencrypted), enabling this option may expose your origin server address to end users. Direct access to origin will disable CDN acceleration.',
      ok: 'OK',
    },
  },

  // 极智压缩
  image_slim: 'Image Smart Compression',
  image_slim_tips_html: 'After enabling the Data Image Smart Compression, images will be automatically compressed when accessed without any additional parameters. It supports JPG/PNG/GIF formats, and retains the original file format after compression. For more details, please see <a href="https://cloud.tencent.com/document/product/436/49259">Image Smart Compression Overview</a>',
  image_slim_auto_opened: 'Auto Compression Enabled (suffix {suffixList})',
  image_slim_auto_label: 'Auto Compression (Recommended)',
  image_slim_auto_tips: 'No need to add any extra parameters, the following image formats will be automatically compressed during normal access.',
  image_slim_suffix_label: 'Image Format',
  image_slim_api_opened: 'API Access Enabled',
  image_slim_api_label: 'Use the API call',
  image_slim_api_tips_html: 'When accessing images, add the Smart Compression parameter <span class="tea-text-warning">imageSlim</span> to the image link to access the compressed image. For more details, please refer to <a href="https://cloud.tencent.com/document/product/460/94856" target="_blank"> Image Smart Compression API Description </a>.',
  image_slim_api_no_need_tips: 'All image formats for automatic compression are currently selected, no need to use via API.',
  image_slim_auto_open_and_suffix_empty_tips: 'Automatic compression has been enabled, at least one image format must be selected.',
  shareInfo: 'For a longer validity period, go to <a href="https://cloud.tencent.com/document/product/436/11366" target="_blank"> COSBrowser for PC </a>When using a key to log in as a sub-account for sharing, the maximum validity period is 30 days.',
};
